export const selectBox = state => state.views.shippingCalculator.box;

export const selectFilterValue = filterName => state =>
    state.views.shippingCalculator.box[filterName];

export const selectIsBoxValid = state =>
    state.views.shippingCalculator.box.height &&
    state.views.shippingCalculator.box.length &&
    state.views.shippingCalculator.box.width &&
    state.views.shippingCalculator.box.weight;

export const selectWeightUnit = state =>
    state.views.shippingCalculator.weightUnit;

export const selectNormalizedWeight = state =>
    state.views.shippingCalculator.box.weight % 1000 === 0
        ? state.views.shippingCalculator.box.weight / 1000
        : state.views.shippingCalculator.box.weight;

export const selectWeightString = state =>
    `${selectNormalizedWeight(state)} ${selectWeightUnit(state)}`;

export const isLoadingShippingProducts = state =>
    state.views.shippingCalculator.isLoadingShippingProducts;

export const selectShippingProviders = state =>
    state.views.shippingCalculator.shippingProviders;

export const selectInternationalShippingProviders = state =>
    state.views.shippingCalculator.shippingProviders.filter(
        ({ providerName }) =>
            ['SchenkerPrivpak', 'PostNordParcel', 'PostNordStamp'].find(
                p => p === providerName
            )
    );

export const selectShippingProductsGroupedByCountry = state =>
    state.views.shippingCalculator.internationalProductsGroupedByCountry;

export const selectIsDifferentFromDefaultBox = state =>
    !(
        state.views.shippingCalculator.box.length ===
            state.views.shippingCalculator.defaultBox.length &&
        state.views.shippingCalculator.box.width ===
            state.views.shippingCalculator.defaultBox.width &&
        state.views.shippingCalculator.box.height ===
            state.views.shippingCalculator.defaultBox.height &&
        state.views.shippingCalculator.box.weight ===
            state.views.shippingCalculator.defaultBox.weight
    );

export const selectSelectedCountry = state =>
    state.views.shippingCalculator.selectedCountry;

export const selectShowError = state =>
    state.views.shippingCalculator.showError;
